module.exports = __webpack_public_path__ + "1050f6eec35bd79a4cf44d41f601c3bf.pdf";